import { render } from "./vmemberBuyRecord.vue?vue&type=template&id=65f1030f&scoped=true"
import script from "./vmemberBuyRecord.vue?vue&type=script&lang=js"
export * from "./vmemberBuyRecord.vue?vue&type=script&lang=js"

import "./vmemberBuyRecord.vue?vue&type=style&index=0&id=65f1030f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f1030f"]])

export default __exports__